import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoShieldFlash16 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M13.3332 4.30913V7.94154C13.3332 11.2286 10.7113 12.6427 8.06738 14.0688L7.99984 14.1053L7.9323 14.0688C5.28833 12.6427 2.6665 11.2286 2.6665 7.94154V4.30913C2.6665 4.02447 2.84725 3.77121 3.11645 3.67868L7.7831 2.07451C7.92357 2.02623 8.0761 2.02623 8.21657 2.07451L12.8832 3.67868C13.1524 3.77121 13.3332 4.02447 13.3332 4.30913Z" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M8.31007 5L6.84521 7.41527C6.84521 7.50085 6.91461 7.57023 7.00017 7.57023H9.37104C9.49482 7.57023 9.56865 7.70817 9.5 7.81115L7.5 11" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoShieldFlash16;